<template>
  <div class="add-files auth-form--wrap-col w-100">
    <div class="input-label">{{ label }}</div>
    <div class="add-files--button">
      <div class="add-files--button-text">Минимум 1, максимум {{ maxFiles }} изображений. Формат – JPG, PNG,
        TIFF или BMP. Размер – не более {{ maxFileSize }} МБ.<br/>Рекомендуемое разрешение – не менее 720 x 720
        пикс. и
        не более 3000 x 3000 пикс.
      </div>
    </div>
    <div class="add-files--list">
      <div class="add-files--photos">
        <div class="add-files--photo" v-if="photo.length" v-for="(f, key) in photo" :key="key">
          <v-avatar class="add-files--image-wrap" tile size="72">
            <img class="add-files--image" :src="f.url || f.base64" alt="image"/>
          </v-avatar>
          <button type="button" aria-label="Удалить изображение" v-if="!disabled" @click="$emit('delete', key)" class="add-files--image-delete">
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z"
                  fill="#D60000"/>
              <path
                  d="M10.6818 12.966L7.47728 9.7797C6.84091 9.01124 6.84091 8.24286 7.47728 7.47456C8.25 6.84181 9.02272 6.84181 9.79544 7.47456L13 10.7288L16.2046 7.54225C16.9773 6.9095 17.75 6.9095 18.5227 7.54225C19.1591 8.31071 19.1591 9.07909 18.5227 9.84739L15.3182 12.966L18.5227 16.1525C19.1591 16.9209 19.1591 17.6893 18.5227 18.4576C17.75 19.0904 16.9773 19.0904 16.2046 18.4576L13 15.3389L9.79544 18.5254C9.02272 19.1582 8.25 19.1582 7.47728 18.5254C6.84091 17.7571 6.84091 16.9887 7.47728 16.2203L10.6818 12.966Z"
                  fill="white"/>
            </svg>
          </button>
        </div>
        <div class="add-files--photo" v-if="photo.length < maxFiles">
          <div class="add-photo">
            <v-file-input
                multiple
                class="mt-0 pt-0"
                accept="image/png, image/jpeg, image/bmp"
                prepend-icon="mdi-camera"
                @change="TransformFile"
                :rules="[rules.fileSize]"
                :hide-input="true"
                :disabled="disabled"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'Photo',
  props: {
    photo: {
      type: Array,
      required: true,
      default: [],
    },
    maxFiles: {
      type: Number,
      default: 1,
    },
    minFiles: {
      type: Number,
      default: 0,
    },
    maxFileSize: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        maxFiles: () => this.photo.length < this.maxFiles || `Количество файлов не более ${this.maxFiles}`,
        minFiles: () => (this.minFiles && this.photo.length >= this.minFiles) || `Количество файлов не менее ${this.minFiles}`,
        fileSize: v => !v || !v.size || v.size < 5242880 || 'Максимальный размер файла 5мб',
      },
    };
  },
  methods: {
    /** Методы для работы с документами */
    async TransformFile(files, idx) {
      const file = files[0];
      const document = { file: '', url: '', name: '' };
      if (!file || file.name.lastIndexOf('.') <= 0) {
        return document;
      }
      const fr = new FileReader();
      await fr.readAsDataURL(file);
      await fr.addEventListener('load', () => {
        document.name = file.name;
        document.file = null;
        document.base64 = fr.result;
        document.key = `${idx}_${Date.now()}`;
        this.$emit('add', document);
      });
      return document;
    },
  },
};
</script>

<style lang="scss">
.add-files {
  margin-bottom: 15px;

  &--button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    &-text {
      font-size: 12px;
    }

    @media (max-width: 600px) {
      flex-direction: column-reverse;
      align-items: flex-start;
      &-text {
        padding-bottom: 15px;
        padding-left: 0;
      }
    }
  }

  &--list {
    display: flex;
    flex-wrap: wrap;
    padding: 0 15px;
    border: 2px dashed #E6E8F0;
    border-radius: 8px;

    .add-photo {
      margin: 15px 30px 15px 0;
    }
  }

  &--photos {
    display: flex;
    flex-wrap: wrap;
  }

  &--photo {
    position: relative;
  }

  &--image-wrap {
    margin: 15px 15px 15px 0;
  }

  &--image {
    border-radius: 8px !important;
  }

  &--image-delete {
    position: absolute;
    top: 2px;
    right: 2px;
  }

  &--image-delete:hover {
    cursor: pointer;
  }
}

.add-photo{
  position: relative;
  width: 72px;
  margin-bottom: 20px;
  .v-input__control{
    display: none;
  }
  .v-input__icon{
    width: auto;
    height: auto;
  }
  .v-input__prepend-outer{
    margin: 0;
    button{
      padding: 18px;
      border: 1px solid #6a6a6a;
      border-radius: 16px;
      font-size: 34px;
      opacity: 0.5;
      &:hover{
        opacity: 1;
      }
      &:after{
        border-radius: 16px;
        transform: scale(1);
      }
    }
  }
  .ico-delete{
    position: absolute;
    right: -5px;
    bottom: -5px;
    line-height: 0;
  }

  .ico-delete:hover{
    cursor: pointer;
  }
}

@media (max-width: 600px) {
  .add-photo {
    width: 50px;
    height: 50px;
    margin: 10px 12px 10px 0;

    .v-input__prepend-outer button {
      padding: 7px;
    }

    .ico-delete {
      width: 20px;
      height: 20px;

      svg {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>